module.exports = __webpack_public_path__ + "static/cs1-84286837e7f4afb883daa7cbdfd70916.jpg";